/**
 * Automatische Handhabung von Button-Ladezuständen.
 * Fügt das .is-loading-icon Element hinzu, wenn ein Button eine der Status-Klassen erhält.
 */
(function() {
    const statusClasses = ['is-loading', 'is-success', 'is-error'];

    /**
     * Prüft, ob ein Element ein Button mit einem relevanten Status ist
     * und fügt das Icon-Element hinzu, falls es fehlt.
     */
    function ensureLoadingIcon(element) {
        if (!element || !element.classList) return;
        
        // Nur für .button oder button Elemente
        if (!element.matches('button') && !element.classList.contains('button')) {
            return;
        }

        const hasStatus = statusClasses.some(cls => element.classList.contains(cls));
        if (hasStatus) {
            let icon = element.querySelector('.is-loading-icon');
            if (!icon) {
                icon = document.createElement('span');
                icon.className = 'is-loading-icon';
                // Wichtig: In das Element einfügen, damit es absolut positioniert werden kann
                element.appendChild(icon);
            }
        }
    }

    /**
     * Initialisierung
     */
    function init() {
        document.querySelectorAll('button, .button').forEach(ensureLoadingIcon);
    }

    /**
     * MutationObserver, um dynamische Klassenänderungen zu überwachen
     */
    const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                ensureLoadingIcon(mutation.target);
            }
            if (mutation.type === 'childList') {
                mutation.addedNodes.forEach(node => {
                    if (node.nodeType === 1) { // Element
                        if (node.matches && (node.matches('button') || node.matches('.button'))) {
                            ensureLoadingIcon(node);
                        }
                        if (node.querySelectorAll) {
                            node.querySelectorAll('button, .button').forEach(ensureLoadingIcon);
                        }
                    }
                });
            }
        });
    });

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => {
            init();
            observer.observe(document.body, {
                attributes: true,
                childList: true,
                subtree: true,
                attributeFilter: ['class']
            });
        });
    } else {
        init();
        observer.observe(document.body, {
            attributes: true,
            childList: true,
            subtree: true,
            attributeFilter: ['class']
        });
    }
})();
